/**
 * @generated SignedSource<<bd331544237112ed1b15be26a8a11ddc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteCustomerCategoryMutation$variables = {
  id: string;
};
export type DeleteCustomerCategoryMutation$data = {
  readonly deleteCustomerCategory: {
    readonly id: string;
  } | null;
};
export type DeleteCustomerCategoryMutation = {
  response: DeleteCustomerCategoryMutation$data;
  variables: DeleteCustomerCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteCustomerCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerCategory",
        "kind": "LinkedField",
        "name": "deleteCustomerCategory",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteCustomerCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerCategory",
        "kind": "LinkedField",
        "name": "deleteCustomerCategory",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3e400bf68e03160764781e4e092d0297",
    "id": null,
    "metadata": {},
    "name": "DeleteCustomerCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteCustomerCategoryMutation(\n  $id: ID!\n) {\n  deleteCustomerCategory(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ba5c2a871a1a7fdb0e28b9946bb961a";

export default node;
